import min from 'lodash/min';
import max from 'lodash/max';

import { createSelector } from 'reselect';

import getParent from '../selectors';

export const getPds = state => getParent(state).pds;

export const doPdsExist = state => !!getPds(state);

const makeGetPdsPropertySelector = property => createSelector(
  getPds, pds => pds && pds.map(pd => pd[property])
);

const getPdsYs = makeGetPdsPropertySelector('y');
const getPdsXs = makeGetPdsPropertySelector('x');

export const getPdsRanges = createSelector(
  getPdsXs,
  getPdsYs,

  (xs, ys) => {
    if (xs && ys && xs.length && ys.length) {
      return {
        x: { min: min(xs), max: max(xs) },
        y: { min: min(ys), max: max(ys) }
      };
    }

    return null;
  }
);
